<template>
  <div>
    <b-container class="home-container container-xl vali-hollow-logo">
      <b-row col="12" class="mb-5">
        <b-col sm="12" md="12" lg="8" xl="6" style=" font-size: 18px; text-align: left">
          <h1 class="text-left">A személyre szabott vállalkozói információ</h1>
          <p class="text-left mt-4" style="font-size: 24px">
            Tájékozódjon a vállalkozása számára elérhető támogatásokról, hitelekről, képzési és szakértői
            szolgáltatásokról.
          </p>
        </b-col>
      </b-row>
      <ifka-vp-programs-highlight />
      <!-- <DSPHeadLine />
      <Fix3kkvBanner /> -->
      <b-row col="12" class="mb-2 mt-0 justify-content-md-center text-left">
        <b-col sm="12" md="12" lg="12" xl="12">
          <h2>
            Böngésszen regisztráció nélkül
          </h2>
        </b-col>
      </b-row>
      <b-row col="12" class="mb-2 justify-content-md-center">
        <b-col cols="12">
          <ifka-vp-search-company />
        </b-col>
      </b-row>
      <ifka-vp-login-banner />
      <ifka-vp-news />
      <ifka-vp-programs />
      <!-- <ifka-vp-services /> -->
      <b-row>
        <b-col xs="12">
          <h2 class="text-left mt-3 mb-5 font-weight-normal">Állandó szolgáltatások</h2>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="Box_padding" cols="12" lg="4">
          <div>
            <b-row class="pt-1">
              <b-col class="ml-4 wrapper p-2">
                <a class="services-button-wrapper" target="blank" href="https://www.vali.hu/ESG">
                  <img class="download-icon" src="../assets/img/service-image_icon.png" />
                  <p class="greenText mb-3 pt-4">ESG oktatás és vállalkozásfejlesztés</p>
                </a>
              </b-col>
            </b-row>
          </div>
        </b-col>

        <b-col class="Box_padding" cols="12" lg="4">
          <div>
            <b-row class="pt-1">
              <b-col class="ml-4 wrapper p-2">
                <a class="services-button-wrapper" target="blank" href="https://vali.mgfu.hu/hu/experts">
                  <img class="download-icon" src="../assets/img/service-image_icon.png" />
                  <p class="greenText mb-3 pt-4">Minősített szakértők</p>
                </a>
              </b-col>
            </b-row>
          </div>
        </b-col>

        <b-col class="Box_padding" cols="12" lg="4">
          <div>
            <b-row class="pt-1">
              <b-col class="ml-4 wrapper p-2">
                <a class="services-button-wrapper" target="blank" href="https://vali.hu/courses">
                  <img class="download-icon" src="../assets/img/service-image_icon.png" />
                  <p class="greenText mb-3 pt-4">Képzések</p>
                </a>
              </b-col>
            </b-row>
          </div>
        </b-col>

        <b-col class="Box_padding" cols="12" lg="4">
          <div>
            <b-row class="pt-1">
              <b-col class="ml-4 wrapper p-2">
                <a class="services-button-wrapper" target="blank" href="https://vali.hu/business-development-services">
                  <img class="download-icon" src="../assets/img/service-image_icon.png" />
                  <p class="greenText mb-3 pt-4">Vállalkozásfejlesztési szolgáltatások</p>
                </a>
              </b-col>
            </b-row>
          </div>
        </b-col>

        <b-col class="Box_padding" cols="12" lg="4">
          <div>
            <b-row class="pt-1">
              <b-col class="ml-4 wrapper p-2">
                <a class="services-button-wrapper" target="blank" href="https://ginopplusz.modem4.hu/">
                  <img class="download-icon" src="../assets/img/service-image_icon.png" />
                  <p class="greenText mb-3 pt-4">Modern Mintaüzem Program</p>
                </a>
              </b-col>
            </b-row>
          </div>
        </b-col>

        <b-col class="Box_padding" cols="12" lg="4">
          <div>
            <b-row class="pt-1">
              <b-col class="ml-4 wrapper p-2">
                <a class="services-button-wrapper" target="blank" href="https://vali.hu/palyazati-utmutato">
                  <img class="download-icon" src="../assets/img/service-image_icon.png" />
                  <p class="greenText mb-3 pt-4">Pályázati útmutatók</p>
                </a>
              </b-col>
            </b-row>
          </div>
        </b-col>

        <b-col class="Box_padding" cols="12" lg="4">
          <div>
            <b-row class="pt-1">
              <b-col class="ml-4 wrapper p-2">
                <a class="services-button-wrapper" target="blank" href="https://vali.hu/kkv-qualifier">
                  <img class="download-icon" src="../assets/img/service-image_icon.png" />
                  <p class="greenText mb-3 pt-4">KKV Minősítés</p>
                </a>
              </b-col>
            </b-row>
          </div>
        </b-col>

        <b-col class="Box_padding" cols="12" lg="4">
          <div>
            <b-row class="pt-1">
              <b-col class="ml-4 wrapper p-2">
                <a class="services-button-wrapper" target="blank" href="https://vali.hu/static/VALI_GYIK.pdf">
                  <img class="download-icon" src="../assets/img/service-image_icon.png" />
                  <p class="greenText mb-3 pt-4">Gyakori kérdések</p>
                </a>
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col xs="12">
          <h2 class="text-left mt-3 mb-5 font-weight-normal">Korábbi támogatási programok</h2>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="Box_padding" cols="12" lg="4">
          <div>
            <b-row class="pt-1">
              <b-col class="ml-4 wrapper p-2">
                <a class="services-button-wrapper" target="blank" href="https://vali.hu/egypluszegy-program">
                  <img class="download-icon" src="../assets/img/service-image_icon.png" />
                  <p class="greenText mb-3 pt-3">Demján Sándor 1+1 KKV Beruházás-élénkítő Támogatási Program 1. Ütem</p>
                </a>
              </b-col>
            </b-row>
          </div>
        </b-col>

        <b-col class="Box_padding" cols="12" lg="4">
          <div>
            <b-row class="pt-1">
              <b-col class="ml-4 wrapper p-2">
                <a class="services-button-wrapper" target="blank" href="https://vali.hu/egypluszegy2-program">
                  <img class="download-icon" src="../assets/img/service-image_icon.png" />
                  <p class="greenText mb-3 pt-3">Demján Sándor 1+1 KKV Beruházás-élénkítő Támogatási Program 2. Ütem</p>
                </a>
              </b-col>
            </b-row>
          </div>
        </b-col>

        <b-col class="Box_padding" cols="12" lg="4">
          <div>
            <b-row class="pt-1">
              <b-col class="ml-4 wrapper p-2">
                <a class="services-button-wrapper" target="blank" href="https://vali.hu/energiatamogatas">
                  <img class="download-icon" src="../assets/img/service-image_icon.png" />
                  <p class="greenText mb-3 pt-3">KKV Energiaköltség és Beruházás Támogatási Program 2022-2023</p>
                </a>
              </b-col>
            </b-row>
          </div>
        </b-col>

        <b-col class="Box_padding" cols="12" lg="4">
          <div>
            <b-row class="pt-1">
              <b-col class="ml-4 wrapper p-2">
                <a class="services-button-wrapper" target="blank" href="https://vali.hu/energetikai-voucher-program">
                  <img class="download-icon" src="../assets/img/service-image_icon.png" />
                  <p class="greenText mb-3 pt-3">MGFÜ Energetikai Tanácsadási Voucher Program</p>
                </a>
              </b-col>
            </b-row>
          </div>
        </b-col>

        <b-col class="Box_padding" cols="12" lg="4">
          <div>
            <b-row class="pt-1">
              <b-col class="ml-4 wrapper p-2">
                <a class="services-button-wrapper" target="blank" href="https://vali.hu/ds-tanacsadasi-voucher-program">
                  <img class="download-icon" src="../assets/img/service-image_icon.png" />
                  <p class="greenText mb-3 pt-3">Demján Sándor Tanácsadási Voucher Program</p>
                </a>
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>

      <div class="opacity-logo">
        <b-img src="../assets/img/logo/vekonylogo_vali_horisontal.svg" class="mt-4 mb-4" />
      </div>
    </b-container>
    <EuropeanAward />
  </div>
</template>

<script>
/* import ConstantServices from '@/components/ConstantServices.vue' */
import LoginBanner from '@/components/LoginBanner.vue'
import News from '@/components/News.vue'
import Programs from '@/components/Programs.vue'
import ProgramsHighlight from '@/components/ProgramsHighlight.vue'
import SearchCompany from '@/components/SearchCompany.vue'
/* import DSPHeadLine from '../components/DSPHeadLine.vue' */
import EuropeanAward from '../components/EuropeanAward.vue'
/* import Fix3kkvBanner from './Fix3kkvBanner.vue' */

export default {
  name: 'Home',
  components: {
    ifkaVpSearchCompany: SearchCompany,
    ifkaVpNews: News,
    ifkaVpPrograms: Programs,
    /* ifkaVpServices: ConstantServices, */
    ifkaVpProgramsHighlight: ProgramsHighlight,
    ifkaVpLoginBanner: LoginBanner,
    /* DSPHeadLine, */
    EuropeanAward
    /* Fix3kkvBanner */
  },
  mounted() {}
}
</script>

<style scoped>
@media (min-width: 992px) {
  .vali-hollow-logo {
    position: relative;
    overflow: hidden;
  }

  .vali-hollow-logo:before {
    content: ' ';
    display: block;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 0;
    opacity: 0.2;
    background-image: url('../assets/img/logo/vekonyvali_hollow.svg');
    background-repeat: no-repeat;
    background-position: 100% 0;
    background-size: 394px;
  }

  .opacity-logo {
    width: 312px;
    max-width: 312px;
    margin: 0 auto;
    opacity: 0.6;
  }

  .Box_padding {
    padding-left: 10px !important;
    padding-right: 19px !important;
    margin-top: 0px;
    margin-bottom: 10px;
  }

  .greenText {
    color: #00903c;
    font-size: 15px;
    font-weight: 400;
  }

  .wrapper {
    background: white;
    border-radius: 16px 0px 16px 16px;
    text-align: left;
    border: 1px solid #ddd;
    flex: 0 0 350px !important;
    max-width: 345px !important;
  }

  .wrapper:hover {
    border-radius: 16px 0px 16px 16px;
  }

  .services-button-wrapper {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    text-decoration: none;
    color: inherit;
  }

  .download-icon {
    width: 35px;
    margin-right: 25px;
  }
}
@media (max-width: 767px) {
  .Box_padding {
    padding-left: 10px !important;
    padding-right: 19px !important;
    margin-top: 0px;
    margin-bottom: 10px;
  }

  .greenText {
    color: #00903c;
    font-size: 14px;
  }

  .wrapper {
    background: white;
    border-radius: 16px 0px 16px 16px;
    text-align: left;
    border: 1px solid #ddd;
    flex: 0 0 350px !important;
    max-width: 350px !important;
  }

  .wrapper:hover {
    border-radius: 16px 0px 16px 16px;
  }

  .services-button-wrapper {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    text-decoration: none;
    color: inherit;
  }

  .download-icon {
    width: 35px;
    margin-right: 25px;
  }
}
</style>
